import { apiMethodWrapper } from '../utils/api.utils'
import {
  apiGatewayAxiosInstance,
  authAxiosInstance,
  axiosInstance,
  axiosV2Instance,
  publicAxiosInstance,
  userAxiosInstance,
} from './axios'

export const api = apiMethodWrapper(axiosInstance)
export const apiV2 = apiMethodWrapper(axiosV2Instance)
export const authApi = apiMethodWrapper(authAxiosInstance)
export const apiGateway = apiMethodWrapper(apiGatewayAxiosInstance)
export const publicApi = apiMethodWrapper(publicAxiosInstance)
export const userApi = apiMethodWrapper(userAxiosInstance)
